import { FavoriteMenuComponent } from './../portal-menu/favorite-menu/favorite-menu.component';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
    selector: 'app-favorites',
    templateUrl: './favorites.component.html',
    styleUrls: ['./favorites.component.css']
})
export class FavoritesComponent implements OnInit {

    // Injected Properties
    @Input() editFavorites: boolean;
    @Input() isDefaultPreferences: boolean;

    // View Properties
    @ViewChild(FavoriteMenuComponent) favoriteMenu: FavoriteMenuComponent;

    // Constructor
    constructor() {}

    // Event Functions
    ngOnInit() {}

    // Callable Methods
    expandAll(expand: boolean) {
        this.favoriteMenu.expandAll(expand);
    }

    save() {
        this.favoriteMenu.save();
    }
}
